"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanSlug = cleanSlug;
exports.createPostSlug = createPostSlug;
exports.domainToUrl = domainToUrl;
exports.getPageUrl = getPageUrl;
exports.getTemplatePath = getTemplatePath;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function createPostSlug(blogRootSlug, postSlug) {
  return [blogRootSlug, postSlug].join('').concat('/');
}
function domainToUrl(domain) {
  if (!domain) {
    return '';
  }
  if (domain.startsWith('http')) {
    return "".concat(domain);
  }
  return "https://".concat(domain);
}
function getPageUrl(website) {
  var slugParts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref = website || {},
    _ref$domains = _ref.domains,
    domains = _ref$domains === void 0 ? [] : _ref$domains;
  var domain = domains.find(function (_ref2) {
    var primaryDomain = _ref2.primaryDomain;
    return primaryDomain;
  });
  if ((0, _isEmpty2["default"])(domain)) {
    return '';
  }
  var siteUrl = domain.url;
  siteUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;
  siteUrl = domainToUrl(siteUrl);
  var slugUrl = slugParts.join('/');
  slugUrl = slugUrl.startsWith('/') ? slugUrl.slice(1) : slugUrl;
  return "".concat(siteUrl, "/").concat(slugUrl);
}
function cleanSlug(slug) {
  if (!slug) {
    return null;
  }
  return slug.replace(/^\/+|\/+$/g, '');
}
function getTemplatePath(templateName) {
  return "./templates/".concat(templateName, "/Template.jsx");
}